import { useEffect, useState } from "react";

// Holds a value back until it has stopped changing. Used for search terms so
// the number of requests follows what someone meant to search for rather than
// how many letters it took to type it.
export function useDebouncedValue<T>(value: T, delayMilliseconds: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMilliseconds);

    return () => clearTimeout(timer);
  }, [value, delayMilliseconds]);

  return settled;
}
